import { Heading } from "components/designV2/heading/heading";
import { Text } from "components/designV2/text/text";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import styled from "styled-components";
import { FormStyled } from "../registrationContainer/registrationContainer.styled";

export const StyledForm = styled(FormStyled)`
  max-width: 420px;
  gap: 16px;
  padding: 0 10px;
`;

export const StepLabel = styled(Text).attrs({
  typography: "s1",
  color: ColorV2.Blue2,
})`
  margin: 0 0 12px 0;
`;

export const StyledTitle = styled(Heading).attrs({
  level: "h3",
})`
  margin: 6px 0 8px 0;
`;

export const FieldLabel = styled(Text).attrs({
  typography: "b2",
  color: ColorV2.Blue4,
})`
  margin: 0;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  button {
    margin-top: 0;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  width: 100%;
`;

export const ContinueButton = styled(PrimaryButton)``;

export const BackButton = styled(SecondaryButton)``;
